<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs12 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Event Log
          </v-card-title>
          <v-card-text>
            <div>
              <v-data-table
                :headers='headers'
                :items='storeState.eventLog'
                must-sort
                pagination-sync.rowPerPage=25
                :rows-per-page-items='paginationItems'
                v-bind:pagination.sync='pagination'
              >
                <template v-slot:items='props'>
                  <td width="1%" style="white-space: nowrap;">
                    {{ props.item.time.toLocaleDateString('en-US') }}
                  </td>
                  <td width="1%" style="white-space: nowrap;">
                    {{ props.item.time.toLocaleTimeString('en-US') }}
                  </td>
                  <td>{{ props.item.text }}</td>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'Log',

  data() {
    return {
      storeState: this.$store.state,
      headers: [
        { text: 'Date', value: 'time' },
        { text: 'Time', value: 'time', sortable: false },
        { text: 'Event', value: 'text' },
      ],
      paginationItems: [10, 20, 50, { text: 'All', value: -1 }],
      pagination: { sortBy: 'time', descending: true, rowsPerPage: 10 },
    };
  },
};
</script>
